<div id="pageContainer" class="page" [ngClass]="{'navStarted': this.FlagService.flagServiceObject[1]['offerJunctureFlag'], 'loading-visible': this.LoadscreenService.loadingVisible}">
  <div id="loadingMask">
    <div class="loading-container text-center">
      <h2 [innerHTML]="this.LoadscreenService.loadingMessage"></h2>
      <img src="assets/union/loading.gif" alt="loading spinner" title="loading spinner">
    </div>
  </div>

  <app-header></app-header>
  <router-outlet></router-outlet>

  <app-toast></app-toast>
</div>

<div id="loader-wrapper" *ngIf="loaderService.isLoaderVisible()">
  <div id="loader"></div>
  <div class="loader-section section-left"></div>
  <div class="loader-section section-right"></div>
</div>
